import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import HelpIcon from "@material-ui/icons/Help";

function InputI18N(props) {
  const {
    id,
    type,
    value,
    error,
    name,
    label,
    placeholder,
    className,
    autoFocus,
    inputProps,
    onChange,
    onLeave,
    size,
    disabled,
    langList,
    isMultilang,
    hint,
  } = props;

  const [tabIndex, setTabIndex] = React.useState(0);

  function handleChange(e) {
    onChange(e, langList[tabIndex]);
  }

  function SimpleDialog(props) {
    const { onClose, hint, open } = props;

    const handleClose = () => {
      onClose();
    };

    return (
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>{hint}</DialogTitle>
      </Dialog>
    );
  }

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      {isMultilang && (
        <TabContext value={tabIndex}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            {/* variant fullWidth и minWidth: 0 — иначе вкладки держат минимальную
                ширину MUI и третья («CN») не помещается в узкий диалог на телефоне:
                она просто обрезается, без скролла и следов, из-за чего китайский
                язык выглядел недоступным. */}
            <TabList
              onChange={(e, val) => setTabIndex(val)}
              variant="fullWidth"
              aria-label="lab API tabs example"
            >
              {langList.map((item, index) => (
                <Tab label={item} value={index} sx={{ minWidth: 0 }} />
              ))}
            </TabList>
          </Box>
        </TabContext>
      )}
      <TextField
        InputProps={{
          endAdornment: hint?(
            <InputAdornment position="start">
              {hint && <HelpIcon onClick={handleClickOpen} />}
            </InputAdornment>
          ):null,
        }}
        className={className}
        fullWidth
        autoComplete="off"
        autoFocus={autoFocus}
        margin="dense"
        placeholder={placeholder}
        id={name}
        name={name}
        label={label}
        variant="outlined"
        value={isMultilang ? value[langList[tabIndex]] : value}
        onChange={handleChange}
      />
      <SimpleDialog
        open={open}
        onClose={handleClose}
        hint={hint ?? "hint text"}
      />
    </Box>
  );
}

export default InputI18N;
